import React from 'react';
import styled from 'styled-components/macro';
import { compose, withHandlers, branch, renderNothing } from 'recompose';
import Dropdown from 'components/base/Dropdown/Dropdown';
import { ButtonWrapper } from 'components/base/Dropdown/shared/styles';
import { MenuRoot } from 'components/base/Menu/index';

export const Buttons = styled('div')<any>`
  display: flex;
  flex-flow: row nowrap;
  position: relative;

  > button {
    flex: 0 0 auto;
    margin-right: 0;
  }

  > *:not(button) {
    flex: 1 1 auto;
    ${({ isToggleShown }): string => isToggleShown && 'margin-right: 0.25em;'}

    button {
      width: 100%;
    }
  }
  ${MenuRoot} ${ButtonWrapper} {
    color: ${({ buttonTextColor }): number => buttonTextColor};
  }
`;

const SortCaret = styled('span')<any>`
  transition: ${({ theme }): string =>
    `opacity ${theme.transitionDuration} ${theme.timingFunction}`};
  opacity: ${({ isActive }): number => (isActive ? 1 : 0.25)};
  transform: scaleY(0.75);
`;

const Toggle = styled('button')`
  background: ${({ theme }): string => theme.Sand};
  color: ${({ theme }): string => theme.NightBlue};
  font-weight: 600;
  line-height: 0.6;
  margin-left: 0.25em;
`;

const ToggleWrapper = styled('div')`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: ${({ theme }): string => theme.spacing.small};
`;

interface ISortProps {
  onChange: any;
  onClick: any;
  dropdownItems: any;
  activeItem: any;
  sortOrder: 'asc' | 'desc';
  itemToString?: any;
  minHeight?: string;
  isToggleCaret: boolean;
  isToggleShown: boolean;
  buttonTextColor?: string;
  isRoundedDropdown?: string;
}

const Sort: React.FC<ISortProps> = ({
  onChange,
  onClick,
  dropdownItems,
  activeItem,
  sortOrder,
  itemToString,
  minHeight,
  isToggleCaret = false,
  isToggleShown = true,
  buttonTextColor,
  isRoundedDropdown,
}) => (
  <Buttons buttonTextColor={buttonTextColor}>
    <Dropdown
      onChange={onChange}
      items={dropdownItems}
      selectedItem={activeItem}
      isToggleCaret={isToggleCaret}
      itemToString={itemToString}
      minHeight={minHeight}
      isRoundedDropdown={isRoundedDropdown}
    />
    {isToggleShown && (
      <Toggle onClick={onClick}>
        <ToggleWrapper>
          <SortCaret isActive={sortOrder === 'asc'}>&#9650;</SortCaret>
          <SortCaret isActive={sortOrder === 'desc'}>&#9660;</SortCaret>
        </ToggleWrapper>
      </Toggle>
    )}
  </Buttons>
);

const hide = (hide: any): any => branch(hide, renderNothing);

export default compose(
  hide((props: any): any => props.hide),
  withHandlers({
    onChange:
      (props) =>
      (item: any): void =>
        props.handleDropdown(item),
    onClick: (props: any) => (): void => props.handleToggle(),
  })
)(Sort as any) as any;
